import React, {useEffect, useState} from "react";
import {Button, Layout} from "antd";
import {Link} from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import {basePath, PATH} from "../../config";
import { redirectTo } from "../../config/CoreMethods";
import {useSelector} from "react-redux";
import {ROUTES as ROUTES_CONFIG} from "../../config/constants";
import axiosData from "../../helpers/axiosData";

const { Content } = Layout

const ForgotPass = () => {

    const [email, setEmail] = useState()

    const sendNewPassword = () => {

        axiosData.post("/api/_web3/user/forgot-password/", {email:email}).then((res) => {
            // console.log('res.data.data', res.data)
            if (res.data.success) {
                
                toast.success('Successfully send. Please, check your email')
                
            } else {
                toast.error('OOPS! Something went wrong.')
            }
        })
    }
    
     

    return (
        <div className="min-h-calc-head h-full flex items-center justify-center" style={{paddingTop: "92px", background: `url(${PATH + 'bg-auth.png'}) center center / cover`}}>
            <div className="container mx-auto">
                <Layout className="bg-transparent h-full">
                    <Content className="pt-4 pb-4 pl-14 pr-14 xs-p-2">
                        <div className="flex flex-col items-center gap-y-5">
                            <div className="login-note">
                                Please make sure you are visiting
                                <div>
                                    <i className="icon-lock-closed text-green-400 mr-1"></i>
                                    <span className="text-green-400"> https://</span>app.metafluence.com
                                </div>
                            </div>
                            <ToastContainer />
                            <div className="flex justify-center">
                                <div className="login-form form-box">
                                    <h1 className="text-center text-white font-normal text-xl mb-6">Forgot Password</h1>
                                    <label htmlFor="acc_username" className="text-white text-base font-light mb-2 block">Email</label>
                                    <div className="flex items-center gap-x-6 mb-4 xs-w-100">
                                        <input
                                            className="bg-indigo-700 border-0 rounded-md text-white login-input w-100"
                                            type="text"
                                            name="email"
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </div>
                                    <div className="flex justify-center mt-7">
                                        <Button type="button" onClick={sendNewPassword} className="border-0 bg-cyan-500 text-indigo-900 hover:bg-cyan-400 rounded-3xl font-medium text-base login-btn flex items-center justify-center gap-x-3">
                                            Reset Password
                                        </Button>
                                    </div>
                                    <div className="mt-5 flex items-center justify-center gap-x-1 gap-y-2 flex-wrap">
                                        <span>Don't have a account?</span>
                                        <div>
                                            • <Link to={ROUTES_CONFIG.register.path} className="text-sm text-cyan-500">New Account</Link> • <Link to={ROUTES_CONFIG.loginPage.path} className="text-sm text-cyan-500">Login</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Content>
                </Layout>
            </div>
        </div>
    )
}

export default ForgotPass;